import { render } from "./Login.vue?vue&type=template&id=8840d122"
import script from "./Login.js?vue&type=script&lang=js"
export * from "./Login.js?vue&type=script&lang=js"

import "./Login.scss?vue&type=style&index=0&lang=scss"
/* custom blocks */
import block0 from "./Login.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FLogin%2FLogin.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__